import { render, staticRenderFns } from "./AdditionalProgressInformation.vue?vue&type=template&id=1b9f6065&scoped=true"
import script from "./AdditionalProgressInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalProgressInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9f6065",
  null
  
)

export default component.exports